<div
  class="approval-preview modal-el"
  (click)="backdropClick($event)"
  data-test-id="doc-approval-preview"
>
  <button
    class="nav-arrow nav-prev"
    type="button"
    [disabled]="index === 0"
    (click)="prev($event)"
    data-test-id="doc-approval-prev"
    aria-label="Previous"
  >
    <img src="/assets/img/icons/left_arrow.svg" alt="previous" />
  </button>

  <div class="approval-box modal-info-box">
    <div class="approval-header">
      <div class="approval-title-box">
        <div class="approval-title" [title]="fileName">{{ fileName }}</div>
        <div class="approval-date">
          {{ current?.document?.createdOn | date : "MM/dd/yyyy hh:mm a" }}
        </div>
      </div>
      <div class="approval-header-right">
        <app-print-layout-toggle
          [checked]="showlayout"
          [disabled]="loadingDoc"
          testId="doc-approval-print-layout"
          (checkedChange)="onPrintLayoutChange($event)"
        ></app-print-layout-toggle>
        <img
          src="/assets/img/icons/download_doc.svg"
          alt="download"
          title="Download"
          (click)="downloadDoc()"
        />
        <img
          src="/assets/img/icons/print_doc.svg"
          alt="print"
          title="Print"
          (click)="printDoc()"
        />
        <span class="approval-counter">{{ index + 1 }} / {{ items.length }}</span>
        <img
          class="approval-close"
          src="/assets/img/icons/close.svg"
          alt="close"
          title="Close"
          (click)="close()"
          data-test-id="doc-approval-close"
        />
      </div>
    </div>

    <div class="approval-content">
      <pdf-viewer
        *ngIf="currentSrc"
        [src]="currentSrc"
        [show-all]="true"
        [render-text]="true"
        [original-size]="false"
        [fit-to-page]="true"
      ></pdf-viewer>
    </div>

    <div class="approval-footer">
      <div
        class="footer-actions"
        [class.with-on-behalf]="canActOnBehalf"
        *ngIf="canActOnCurrent()"
      >
        <!--
          ECDEV-412: a CM Admin records the approval (or rejection) of the Customer, CM Inventory
          or both. Locked while the rejection reason is being picked, so the reason cannot end up
          against a different party than the one shown.
        -->
        <mat-form-field
          *ngIf="canActOnBehalf"
          appearance="outline"
          class="on-behalf"
          subscriptSizing="dynamic"
        >
          <mat-select
            placeholder="On behalf of"
            disableRipple
            hideSingleSelectionIndicator
            [disabled]="isRejecting"
            [ngModel]="selectedParty || null"
            (ngModelChange)="selectParty($event)"
            data-test-id="doc-approval-on-behalf"
          >
            <mat-select-trigger>
              On behalf of: {{ onBehalfLabel }}
            </mat-select-trigger>
            <mat-option
              *ngFor="let opt of onBehalfOptions"
              [value]="opt.value"
              [attr.data-test-id]="'doc-approval-on-behalf-option-' + opt.value"
              >{{ opt.label }}</mat-option
            >
          </mat-select>
          <mat-icon matSuffix class="select-icon-replacement"
            >expand_more</mat-icon
          >
        </mat-form-field>

        <ng-container *ngIf="!isRejecting">
          <button
            type="button"
            class="action-btn approve-btn"
            [disabled]="!roleToActOn"
            (click)="onApprove()"
            data-test-id="doc-approval-approve"
          >
            Approve
          </button>
          <button
            type="button"
            class="action-btn reject-btn"
            [disabled]="!roleToActOn"
            (click)="startReject()"
            data-test-id="doc-approval-reject"
          >
            Reject
          </button>
        </ng-container>

        <ng-container *ngIf="isRejecting">
          <mat-form-field
            appearance="outline"
            class="reject-reason"
            subscriptSizing="dynamic"
          >
            <mat-select
              placeholder="Rejection reason"
              disableRipple
              hideSingleSelectionIndicator
              [(ngModel)]="rejectReason"
              data-test-id="doc-approval-reason"
            >
              <mat-option
                *ngFor="let reason of rejectionReasons"
                [value]="reason"
                >{{ reason }}</mat-option
              >
            </mat-select>
            <mat-icon matSuffix class="select-icon-replacement"
              >expand_more</mat-icon
            >
          </mat-form-field>
          <button
            type="button"
            class="action-btn reject-btn"
            [disabled]="!rejectReason"
            (click)="onReject()"
            data-test-id="doc-approval-reject-confirm"
          >
            Confirm
          </button>
          <button
            type="button"
            class="action-btn cancel-btn"
            (click)="cancelReject()"
            data-test-id="doc-approval-reject-cancel"
          >
            Cancel
          </button>
        </ng-container>
      </div>

      <div
        class="footer-blocked"
        *ngIf="blockedReason"
        data-test-id="doc-approval-blocked"
      >
        <img src="/assets/img/icons/warning_orange.svg" alt="info" />
        <span>{{ blockedReason }}</span>
      </div>

      <div class="footer-status">
        <span
          class="status-chip no-approval"
          *ngIf="noApprovalRequired(current)"
          >No approval required</span
        >
        <ng-container *ngIf="!noApprovalRequired(current)">
          <span
            class="status-chip"
            *ngIf="slotState(current, role.Customer) !== 'na'"
            [ngClass]="'chip-' + slotState(current, role.Customer)"
          >
            Customer {{ slotState(current, role.Customer) }}
          </span>
          <span
            class="status-chip"
            *ngIf="slotState(current, role.CmInventory) !== 'na'"
            [ngClass]="'chip-' + slotState(current, role.CmInventory)"
          >
            CM Inventory {{ slotState(current, role.CmInventory) }}
          </span>
        </ng-container>
      </div>

      <button
        type="button"
        class="action-btn close-btn"
        (click)="close()"
        data-test-id="doc-approval-close-btn"
      >
        Close
      </button>
    </div>
  </div>

  <button
    class="nav-arrow nav-next"
    type="button"
    [disabled]="index === items.length - 1"
    (click)="next($event)"
    data-test-id="doc-approval-next"
    aria-label="Next"
  >
    <img src="/assets/img/icons/right_arrow.svg" alt="next" />
  </button>
</div>
